import { css, Interpolation } from 'styled-components';

export const sizes = {
  large: 1200,
  desktop: 992,
  tablet: 768,
} as const;

export type MediaSizes = keyof typeof sizes;

// Deprecated
export const media = (Object.keys(sizes) as MediaSizes[]).reduce(
  (
    accumulator: Record<
      MediaSizes,
      (
        first: TemplateStringsArray,
        ...interpolations: Interpolation<any>[]
      ) => ReturnType<typeof css>
    >,
    currentValue: MediaSizes,
  ) => {
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    const emSize = sizes[currentValue] / 16;

    accumulator[currentValue] = (
      first: TemplateStringsArray,
      ...interpolations: Interpolation<any>[]
    ) => css`
      @media (min-width: ${emSize}em) {
        ${css(first, ...interpolations)};
      }
    `;

    return accumulator;
  },
  {} as Record<
    MediaSizes,
    (
      first: TemplateStringsArray,
      ...interpolations: Interpolation<any>[]
    ) => ReturnType<typeof css>
  >,
);

const mediaQuery = (minWidth: number) =>
  `@media screen and (min-width: ${minWidth}em)`;

export const screens = {
  sm: mediaQuery(360 / 16),
  md: mediaQuery(768 / 16),
  lg: mediaQuery(992 / 16),
  xl: mediaQuery(1200 / 16),
  xxl: mediaQuery(1440 / 16),
};
